import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#008300]/80 text-white">

      {/* ================= TOP LINKS ================= */}
      <div className="max-w-6xl mx-auto px-6 pt-12">
        <ul className="flex flex-wrap justify-center gap-6 sm:gap-10 text-sm font-semibold uppercase tracking-wider">
          {[
            { label: "HOME", link: "/" },
            { label: "About Us", link: "/about" },
            { label: "FAQs", link: "/faqs" },
            { label: "gallery", link: "/gallery" },
            { label: "Contact", link: "/contact" },
          ].map((item, i) => (
            <li key={i}>
              <Link
                to={item.link}
                className="
          hover:opacity-80
          transition
          hover:underline
        "
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Divider */}
        <div className="my-8 border-t border-white/30"></div>

        {/* ================= CENTER TEXT ================= */}
        <p className="max-w-3xl mx-auto text-center text-sm leading-relaxed text-white/90">
          Empowering businesses with{" "}
          <span className="font-semibold">
            AI-powered SEO automation
          </span>{" "}
          and actionable insights for measurable digital growth.
        </p>

        {/* ================= SOCIAL ICONS ================= */}
        <div className="flex justify-center gap-5 mt-8">
          {[
            {
              icon: <FaFacebookF />,
              link: "https://www.facebook.com/profile.php?id=61587376600109",
            },
            {
              icon: <FaTwitter />,
              link: "https://x.com/up_rank88919",
            },
            {
              icon: <FaInstagram />,
              link: "https://www.instagram.com/novarsis_seo_up_rank/",
            },
            {
              icon: <FaLinkedinIn />,
              link: "https://www.linkedin.com/in/seo-up-rank-95a3273ab/",
            },
          ].map((item, i) => (
            <a
              key={i}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="
                w-9 h-9 flex items-center justify-center
                rounded-full
                bg-white/20
                hover:bg-white hover:text-[#008300]
                transition-all duration-300
              "
            >
              {item.icon}
            </a>
          ))}
        </div>
        {/* ================= CONTACT INFO ================= */}
        <p className="max-w-4xl mx-auto mt-6 flex flex-wrap justify-center items-center gap-6 sm:gap-8
  text-center text-sm leading-relaxed text-white/90">

          <span className="flex items-center gap-2">
            <FaMapMarkerAlt className="text-white/80" />
            Vijay Nagar, Indore
          </span>

          <span className="hidden sm:block opacity-40">|</span>

          <span className="flex items-center gap-2">
            <FaPhoneAlt className="text-white/80" />
            +91 9111720303
          </span>

          <span className="hidden sm:block opacity-40">|</span>

          <span className="flex items-center gap-2">
            <FaEnvelope className="text-white/80" />
            info@novarsistech.com
          </span>

        </p>
      </div>

      {/* ================= BOTTOM BAR ================= */}
      <div className="mt-10 py-4 border-t border-white/30 text-center text-sm text-white/90">
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-2">
          <Link to="/privacy-policy" className="hover:underline">
            Privacy Policy
          </Link>
          <span className="hidden sm:block">|</span>
          <Link to="/terms-conditions" className="hover:underline">
            Terms & Conditions
          </Link>
        </div>

        © {new Date().getFullYear()}{" "}
        <span className="font-semibold">Seo Up Rank</span>. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;